<template>
<div>
  <el-card body-style="padding: 0">
    <div slot="header" class="clearfix">
      <span style="color: #409EFF">商家定价</span>
    </div>
    <el-form ref="queryForm" :model="queryForm" label-width="100px">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item label="用户名" prop="saleman">
            <el-input v-model="queryForm.saleman" placeholder="请输入用户名"/>
          </el-form-item>
        </el-col>
        <el-col :span="8" :offset="6">
          <el-form-item>
            <el-button type="primary" size="small"
                       @click="submitQueryForm()" icon="el-icon-search">
              查询
            </el-button>
            <el-button type="primary" size="small" plain
                       @click="resetQueryForm()" icon="el-icon-refresh">
              重置
            </el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-card>

  <el-card>
    <el-button type="primary" size="small" style="margin: 0 0 10px 20px"
               icon="el-icon-plus" @click="handleAllUserPrice('添加通用定价')">添加通用定价
    </el-button>
    <el-button type="primary" size="small" style="margin: 0 0 10px 20px"
               icon="el-icon-plus" @click="handleAdd('添加指定定价')">添加指定定价
    </el-button>
    <el-table :data="tableData"
              border default-expand-all stripe
              :header-cell-style="{'text-align':'center'}"
              style="width: 100%;margin-bottom: 20px;"
              :cell-style="{'text-align':'center'}">
      <el-table-column prop="id" label="定价ID"/>
      <el-table-column prop="priceName" label="用户名"/>
      <el-table-column prop="createTime" label="添加时间"/>
      <el-table-column prop="updateTime" label="更新时间"/>
      <el-table-column prop="remarks" label="备注"/>
      <el-table-column label="操作" width="200" align="center">
        <template slot-scope="scope">
          <el-button size="mini" type="text"
                     @click="handlePriceModeEdit(scope.$index, scope.row)">
            调整
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        :page-sizes="[20, 50, 100, 200]"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="pagination.pageNum"
        :page-size="pagination.pageSize"
        :total="pagination.total"
        @size-change="handlePageSizeChange"
        @current-change="handlePageNumChange"
        background
        style="float: right;margin-bottom: 10px">
    </el-pagination>
  </el-card>

  <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible">
    <el-form ref="dialogForm" :model="dialogForm" label-width="220px">
      <el-form-item label="商家: ">
        <el-input v-model="dialogForm.businessName" style="width: 50%;"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="addBusinessPriceData" size="mini" type="primary">确认添加定价</el-button>
      <el-button @click="handleCloseDialog" size="mini">取 消</el-button>
    </div>
  </el-dialog>

</div>
</template>

<script>
import {querySalemanPriceModeData} from "../../api/b2cbusiness/b2c_saleman";
import MixinCUD from "../../components/MixinCUD";

export default {
name: "MyBusinessPriceLimit",
  mixins: [MixinCUD],
  data(){
  return {
    tableData: [],
    queryFormRefName:"queryForm",
    queryForm: {
      saleman: ''
    },
    dialogFormVisible: false,
    dialogTitle: "",
    dialogRefName: "dialogForm",
    dialogForm:{
    },
    pagination: {
      pageNum: 1,
      pageSize: 20,
      total: null
    },
  }
  },
  mounted() {
  this.getData();
  },
  methods:{
    handleAllUserPrice(){
      this.$router.push({path:'/home/addpricesetting', query:{userName:null, priceModeType:1, modelId:null}});
    },
    handlePriceModeEdit(index, row){
      this.$router.push({path:'/home/addpricesetting', query:{userName:row.priceName, priceModeType:1, modelId:row.id}});
    },
    addBusinessPriceData(){
      this.dialogFormVisible = false;
      this.$router.push({path:'/home/addpricesetting', query:{userName:this.dialogForm.businessName, priceModeType:1, modelId:null}});
    },
  getData(){
    this.queryForm.priceModeType = 1;
    querySalemanPriceModeData(this.queryForm, this.pagination).then(res=>{
      if (res.success){
        this.tableData = res.data.records;
        this.pagination.pageNum = res.data.current;
        this.pagination.pageSize = res.data.size;
        this.pagination.total = res.data.total;
      }
    });
  },
    handlePageSizeChange(val) {
      this.pagination.pageSize = val;
      this.submitQueryForm()
    },
    handlePageNumChange(val) {
      this.pagination.pageNum = val;
      this.submitQueryForm()
    },
  }
}
</script>

<style lang="scss" scoped>
.el-form {
  margin-top: 20px;
}
</style>
